
/**
 * Generates user initials from a full name
 * @param name The user's full name
 * @returns A string of up to two uppercase initials
 */
export const generateInitials = (name: string | null | undefined): string => {
  if (!name) return "?";
  
  const names = name.trim().split(/\s+/);
  
  if (names.length === 0) return "?";
  if (names.length === 1) {
    return names[0].charAt(0).toUpperCase();
  }
  
  // Get first and last name initials
  return `${names[0].charAt(0)}${names[names.length - 1].charAt(0)}`.toUpperCase();
};
